import React, { useEffect, useState } from 'react';
import { View, StyleSheet, TouchableOpacity, ScrollView } from 'react-native';
import { Ionicons, MaterialCommunityIcons, FontAwesome5, MaterialIcons } from '@expo/vector-icons';
import Svg, { Circle, Text } from 'react-native-svg';
import { LinearGradient } from 'expo-linear-gradient';
import { useDispatch, useSelector } from 'react-redux';
import HorizontalTabSlider from './HorizontalTabSlider';
import Dialog from '@material-ui/core/Dialog';
import DialogButton from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import ajax from '../../../../../helpers/ajaxHelper';
import Urls from '../../../../../services/Urls';
import { showErrorToast, showSuccesToast } from '../../helpers';
import { tenantActions } from '../../../redux/tenant.actions';
import { navigate } from '../../../../../navigation/RootNavigation';
import { CardMedia } from '@mui/material';
import { Text as RNText } from 'react-native';
import getPlatformType from '../../../../../helpers/helpers';
import { COLORS } from './PropertyDetailsCard';
import ActivityTimelineModal from '../modals/ActivityTimelineModal';

const FlatOverviewCard = (props) => {
  const [data, setData] = useState({
    completed: 0
  })
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [showArchiveModal, setShowArchiveModal] = useState(false);
  const [showUnArchiveModal, setShowUnArchiveModal] = useState(false);
  const [activityTimelineModalmodalVisible, setactivityTimelineModalVisible] = useState(false);


  const openFlow = useSelector((state) => state?.tenant.flowIdInfo);
  useEffect(() => {
    setData({
      coverImg:
        openFlow?.property?.property_images.length > 0
          ? openFlow?.property?.property_images[0]
          : require("./profile-banner.png"),
      postcode: `${openFlow?.property?.postcode}`,
      fullName: `${openFlow?.property?.display_address}`,
      completed: openFlow?.percentage_completed ? openFlow?.percentage_completed : 0
    })
  }, [openFlow,])
  const ProgressCircle = ({ percentage }) => {
    const radius = 30;
    const strokeWidth = 6;
    const circumference = 2 * Math.PI * radius;
    const strokeDashoffset = circumference - (circumference * (data.completed ? data.completed : 0)) / 100;

    return (
      <Svg width="80" height="80" viewBox="0 0 80 80">
        <Circle
          stroke="#d1d5db"
          fill="none"
          cx="40"
          cy="40"
          r={radius}
          strokeWidth={strokeWidth}
        />
        <Circle
          stroke="#ec4899"
          fill="none"
          cx="40"
          cy="40"
          r={radius}
          strokeWidth={strokeWidth}
          strokeDasharray={`${circumference}`}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
        />
        <Text
          x="40"
          y="40"
          alignmentBaseline="middle"
          textAnchor="middle"
          fontSize="12"
          fill="#6b7280"
          fontFamily='Lato'
        >
          {percentage}%
        </Text>
      </Svg>
    );
  };
  const [showCompleteWarningModal, setShowCompleteWarningModal] = useState(false)
  const openflow_id = useSelector((state) => state?.tenant?.flowIdInfo?.openflow_id);
  const flow = useSelector((state) => state?.tenant?.flowIdInfo);

  const [showCompleteModal, setShowCompleteModal] = useState(false)
  const steps = [
    'tenancy_status',
    'doc_status',
    'rental_offer_status',
    'holding_deposit_status',
    'verification_status',
    'landlord_status',
    'move_in_status',
    'property_status'
  ]
  const handleCompleteClick = () => {
    const inCompleteSteps = steps.filter((step) => {
      return flow[step] != 1
    })
    if (inCompleteSteps.length > 0) {
      setShowCompleteWarningModal(true)
    } else {
      setShowCompleteModal(true)
    }
  }
  const dispatch = useDispatch()
  const layout = getPlatformType();
  const ActionButton = ({ icon, label, color, onPress }) => (
    <TouchableOpacity onPress={onPress} style={styles.actionButton}>
      <MaterialIcons name={icon} size={20} color={color} />
      <RNText style={[styles.actionLabel, { color }]}>{label}</RNText>
    </TouchableOpacity>
  );
  return (
    <>
      <View style={styles.card}>
        {/* Banner */}
        <CardMedia
          component='img'
          alt='profile-header'
          image={data.coverImg}
          sx={{ height: { xs: 120, md: 150 }, img: { width: '100%', height: '100%' } }}
        />

        {/* Content */}
        <View style={styles.content}>
          {/* Address */}
          <View style={{ flexDirection: "column", flex: 0.7 }}>
            <View style={{ flexWrap: "wrap", flexDirection: layout == "phone" ? 'column' : 'row', gap: 12 }}>

              <RNText style={styles.addressText}>
                {data?.fullName}
              </RNText>
              <View style={styles.iconsRow}>

                <View style={styles.topActions}>
                  {flow?.is_completed ? null : <ActionButton
                    onPress={() => setShowConfirmDialog(true)}
                    icon="delete"
                    label="Delete"
                    color={COLORS.danger}
                  />}

                  {flow?.is_archived ? (
                    <ActionButton
                      onPress={() => setShowUnArchiveModal(true)}
                      icon="unarchive"
                      label="Unarchive"
                      color={COLORS.info}
                    />
                  ) : (
                    <ActionButton
                      onPress={() => setShowArchiveModal(true)}
                      icon="archive"
                      label="Archive"
                      color={COLORS.info}
                    />
                  )}
                  <ActionButton
                    onPress={() => setactivityTimelineModalVisible(true)}
                    icon="archive"
                    label="Logs"
                    color={COLORS.secondary}
                  />
                </View>

              </View>
            </View>
            {/* Icons Row */}
            {/* <View style={styles.iconsRow}>
       {openFlow?.is_completed ?  <MaterialCommunityIcons name="trash-can-outline" size={22} color="#f87171" />:null}
        {openFlow?.is_archived ?   <MaterialCommunityIcons name="download-outline" size={22} color="#60a5fa" />:null}
        </View> */}
          </View>
          {/* Progress + Mark complete */}
          <View style={[styles.progressRow, { flexDirection: layout == 'phone' ? 'column-reverse' : 'row', flex: 0.3 }]}>

            <TouchableOpacity onPress={() => {
              handleCompleteClick()
            }} style={styles.completeRow}>
              <FontAwesome5 name="check-circle" size={22} color="#22c55e" />
              <RNText style={styles.completeText}>Mark as complete</RNText>
            </TouchableOpacity>
            <View style={{ alignItems: 'center' }}>
              <ProgressCircle percentage={data?.completed} />
              {/* <Text style={styles.progressText}>{data?.completed}% complete</Text> */}
            </View>

          </View>
        </View>
      </View>
      <HorizontalTabSlider props={props} />
      <ActivityTimelineModal
        isVisible={activityTimelineModalmodalVisible}
        flowId={openflow_id}
        logs={[
          {
            "openflow_log_id": 28767,
            "user_id": 1,
            "openflow_id": 2287,
            "description": "OpenFlo created!",
            "event_type": "FLO_CREATED",
            "createdAt": "2025-06-10T07:07:06.760Z",
            "updatedAt": "2025-06-10T07:07:06.760Z",
            "user": {
              "user_id": 1,
              "first_name": "Winston",
              "last_name": "Churchill"
            }
          },
          {
            "openflow_log_id": 28769,
            "user_id": 1,
            "openflow_id": 2287,
            "description": "Tenant updated - Steven Day",
            "event_type": "TENANT_UPDATED",
            "createdAt": "2025-06-10T07:08:57.910Z",
            "updatedAt": "2025-06-10T07:08:57.910Z",
            "user": {
              "user_id": 1,
              "first_name": "Winston",
              "last_name": "Churchill"
            }
          },
          {
            "openflow_log_id": 28770,
            "user_id": 1,
            "openflow_id": 2287,
            "description": "Tenant updated - Steven Day",
            "event_type": "TENANT_UPDATED",
            "createdAt": "2025-06-10T07:19:11.174Z",
            "updatedAt": "2025-06-10T07:19:11.174Z",
            "user": {
              "user_id": 1,
              "first_name": "Winston",
              "last_name": "Churchill"
            }
          },
          {
            "openflow_log_id": 28771,
            "user_id": 1,
            "openflow_id": 2287,
            "description": "Tenant updated - virat kohli",
            "event_type": "TENANT_UPDATED",
            "createdAt": "2025-06-10T07:19:11.307Z",
            "updatedAt": "2025-06-10T07:19:11.307Z",
            "user": {
              "user_id": 1,
              "first_name": "Winston",
              "last_name": "Churchill"
            }
          },
          {
            "openflow_log_id": 28835,
            "user_id": 1,
            "openflow_id": 2287,
            "description": "Tenant updated - Steven Day",
            "event_type": "TENANT_UPDATED",
            "createdAt": "2025-06-10T15:48:25.118Z",
            "updatedAt": "2025-06-10T15:48:25.118Z",
            "user": {
              "user_id": 1,
              "first_name": "Winston",
              "last_name": "Churchill"
            }
          },
          {
            "openflow_log_id": 28836,
            "user_id": 1,
            "openflow_id": 2287,
            "description": "Tenant updated - virat kohli",
            "event_type": "TENANT_UPDATED",
            "createdAt": "2025-06-10T15:48:25.215Z",
            "updatedAt": "2025-06-10T15:48:25.215Z",
            "user": {
              "user_id": 1,
              "first_name": "Winston",
              "last_name": "Churchill"
            }
          },
          {
            "openflow_log_id": 29462,
            "user_id": 1,
            "openflow_id": 2287,
            "description": "Landlord added - virat kohli",
            "event_type": "LANDLORD_ADDED",
            "createdAt": "2025-06-17T09:42:34.283Z",
            "updatedAt": "2025-06-17T09:42:34.283Z",
            "user": {
              "user_id": 1,
              "first_name": "Winston",
              "last_name": "Churchill"
            }
          },
          {
            "openflow_log_id": 29513,
            "user_id": 1,
            "openflow_id": 2287,
            "description": "Landlord removed - virat kohli",
            "event_type": "LANDLORD_REMOVED",
            "createdAt": "2025-06-17T10:29:50.086Z",
            "updatedAt": "2025-06-17T10:29:50.086Z",
            "user": {
              "user_id": 1,
              "first_name": "Winston",
              "last_name": "Churchill"
            }
          },
          {
            "openflow_log_id": 29918,
            "user_id": 1,
            "openflow_id": 2287,
            "description": "Landlord added - rushikesh jadhav",
            "event_type": "LANDLORD_ADDED",
            "createdAt": "2025-06-18T08:52:09.331Z",
            "updatedAt": "2025-06-18T08:52:09.331Z",
            "user": {
              "user_id": 1,
              "first_name": "Winston",
              "last_name": "Churchill"
            }
          },
          {
            "openflow_log_id": 29919,
            "user_id": 1,
            "openflow_id": 2287,
            "description": "Landlord added - narandra modi",
            "event_type": "LANDLORD_ADDED",
            "createdAt": "2025-06-18T08:53:47.461Z",
            "updatedAt": "2025-06-18T08:53:47.461Z",
            "user": {
              "user_id": 1,
              "first_name": "Winston",
              "last_name": "Churchill"
            }
          },
          {
            "openflow_log_id": 30578,
            "user_id": 1,
            "openflow_id": 2287,
            "description": "Rental offer created",
            "event_type": "RENTAL_OFFER_CREATED",
            "createdAt": "2025-06-23T06:48:15.410Z",
            "updatedAt": "2025-06-23T06:48:15.410Z",
            "user": {
              "user_id": 1,
              "first_name": "Winston",
              "last_name": "Churchill"
            }
          },
          {
            "openflow_log_id": 30579,
            "user_id": 1,
            "openflow_id": 2287,
            "description": "Rental offer updated",
            "event_type": "RENTAL_OFFER_UPDATED",
            "createdAt": "2025-06-23T06:48:48.770Z",
            "updatedAt": "2025-06-23T06:48:48.770Z",
            "user": {
              "user_id": 1,
              "first_name": "Winston",
              "last_name": "Churchill"
            }
          },
          {
            "openflow_log_id": 30580,
            "user_id": 1,
            "openflow_id": 2287,
            "description": "Rental offer updated",
            "event_type": "RENTAL_OFFER_UPDATED",
            "createdAt": "2025-06-23T06:49:39.160Z",
            "updatedAt": "2025-06-23T06:49:39.160Z",
            "user": {
              "user_id": 1,
              "first_name": "Winston",
              "last_name": "Churchill"
            }
          },
          {
            "openflow_log_id": 30581,
            "user_id": 1,
            "openflow_id": 2287,
            "description": "Rental offer updated",
            "event_type": "RENTAL_OFFER_UPDATED",
            "createdAt": "2025-06-23T06:50:31.900Z",
            "updatedAt": "2025-06-23T06:50:31.900Z",
            "user": {
              "user_id": 1,
              "first_name": "Winston",
              "last_name": "Churchill"
            }
          },
          {
            "openflow_log_id": 30582,
            "user_id": 1,
            "openflow_id": 2287,
            "description": "Rental offer updated",
            "event_type": "RENTAL_OFFER_UPDATED",
            "createdAt": "2025-06-23T06:57:35.936Z",
            "updatedAt": "2025-06-23T06:57:35.936Z",
            "user": {
              "user_id": 1,
              "first_name": "Winston",
              "last_name": "Churchill"
            }
          },
          {
            "openflow_log_id": 30583,
            "user_id": 1,
            "openflow_id": 2287,
            "description": "Rental offer updated",
            "event_type": "RENTAL_OFFER_UPDATED",
            "createdAt": "2025-06-23T06:58:32.251Z",
            "updatedAt": "2025-06-23T06:58:32.251Z",
            "user": {
              "user_id": 1,
              "first_name": "Winston",
              "last_name": "Churchill"
            }
          },
          {
            "openflow_log_id": 30584,
            "user_id": 1,
            "openflow_id": 2287,
            "description": "Rental offer updated",
            "event_type": "RENTAL_OFFER_UPDATED",
            "createdAt": "2025-06-23T07:01:20.757Z",
            "updatedAt": "2025-06-23T07:01:20.757Z",
            "user": {
              "user_id": 1,
              "first_name": "Winston",
              "last_name": "Churchill"
            }
          },
          {
            "openflow_log_id": 30585,
            "user_id": 1,
            "openflow_id": 2287,
            "description": "Rental offer updated",
            "event_type": "RENTAL_OFFER_UPDATED",
            "createdAt": "2025-06-23T07:12:40.936Z",
            "updatedAt": "2025-06-23T07:12:40.936Z",
            "user": {
              "user_id": 1,
              "first_name": "Winston",
              "last_name": "Churchill"
            }
          },
          {
            "openflow_log_id": 30586,
            "user_id": 1,
            "openflow_id": 2287,
            "description": "APT agreement generated",
            "event_type": "AST_AGREEMENT_GENERATED",
            "createdAt": "2025-06-23T07:37:00.266Z",
            "updatedAt": "2025-06-23T07:37:00.266Z",
            "user": {
              "user_id": 1,
              "first_name": "Winston",
              "last_name": "Churchill"
            }
          },
          {
            "openflow_log_id": 30587,
            "user_id": 1,
            "openflow_id": 2287,
            "description": "APT agreement deleted",
            "event_type": "AST_AGREEMENT_DELETED",
            "createdAt": "2025-06-23T07:41:00.022Z",
            "updatedAt": "2025-06-23T07:41:00.022Z",
            "user": {
              "user_id": 1,
              "first_name": "Winston",
              "last_name": "Churchill"
            }
          },
          {
            "openflow_log_id": 30588,
            "user_id": 1,
            "openflow_id": 2287,
            "description": "APT agreement generated",
            "event_type": "AST_AGREEMENT_GENERATED",
            "createdAt": "2025-06-23T07:41:29.264Z",
            "updatedAt": "2025-06-23T07:41:29.264Z",
            "user": {
              "user_id": 1,
              "first_name": "Winston",
              "last_name": "Churchill"
            }
          },
          {
            "openflow_log_id": 30589,
            "user_id": 1,
            "openflow_id": 2287,
            "description": "APT agreement deleted",
            "event_type": "AST_AGREEMENT_DELETED",
            "createdAt": "2025-06-23T07:42:45.717Z",
            "updatedAt": "2025-06-23T07:42:45.717Z",
            "user": {
              "user_id": 1,
              "first_name": "Winston",
              "last_name": "Churchill"
            }
          },
          {
            "openflow_log_id": 30590,
            "user_id": 1,
            "openflow_id": 2287,
            "description": "APT agreement generated",
            "event_type": "AST_AGREEMENT_GENERATED",
            "createdAt": "2025-06-23T07:43:15.377Z",
            "updatedAt": "2025-06-23T07:43:15.377Z",
            "user": {
              "user_id": 1,
              "first_name": "Winston",
              "last_name": "Churchill"
            }
          },
          {
            "openflow_log_id": 30897,
            "user_id": 1,
            "openflow_id": 2287,
            "description": "Full reference started for Steven Day",
            "event_type": "FULL_REFERENCE_STARTED",
            "createdAt": "2025-06-25T11:44:54.288Z",
            "updatedAt": "2025-06-25T11:44:54.288Z",
            "user": {
              "user_id": 1,
              "first_name": "Winston",
              "last_name": "Churchill"
            }
          },
          {
            "openflow_log_id": 30900,
            "user_id": 1,
            "openflow_id": 2287,
            "description": "referencing document uploaded for Steven Day",
            "event_type": "REFERENCING_DOCUMENT_UPLOADED",
            "createdAt": "2025-06-25T11:46:43.650Z",
            "updatedAt": "2025-06-25T11:46:43.650Z",
            "user": {
              "user_id": 1,
              "first_name": "Winston",
              "last_name": "Churchill"
            }
          },
          {
            "openflow_log_id": 30901,
            "user_id": 1,
            "openflow_id": 2287,
            "description": "referencing document deleted for Steven Day",
            "event_type": "referencing_DOCUMENT_DELETED",
            "createdAt": "2025-06-25T11:46:59.342Z",
            "updatedAt": "2025-06-25T11:46:59.342Z",
            "user": {
              "user_id": 1,
              "first_name": "Winston",
              "last_name": "Churchill"
            }
          },
          {
            "openflow_log_id": 30905,
            "user_id": 1,
            "openflow_id": 2287,
            "description": "Guarantor added for Steven Day",
            "event_type": "GUARANOR_ADDED",
            "createdAt": "2025-06-25T11:51:15.046Z",
            "updatedAt": "2025-06-25T11:51:15.046Z",
            "user": {
              "user_id": 1,
              "first_name": "Winston",
              "last_name": "Churchill"
            }
          },
          {
            "openflow_log_id": 30962,
            "user_id": 1,
            "openflow_id": 2287,
            "description": "Guarantor deleted abc xyz",
            "event_type": "GUARANOR_DELETED",
            "createdAt": "2025-06-26T05:16:09.648Z",
            "updatedAt": "2025-06-26T05:16:09.648Z",
            "user": {
              "user_id": 1,
              "first_name": "Winston",
              "last_name": "Churchill"
            }
          },
          {
            "openflow_log_id": 30963,
            "user_id": 1,
            "openflow_id": 2287,
            "description": "referencing document uploaded for Steven Day",
            "event_type": "REFERENCING_DOCUMENT_UPLOADED",
            "createdAt": "2025-06-26T09:11:07.297Z",
            "updatedAt": "2025-06-26T09:11:07.297Z",
            "user": {
              "user_id": 1,
              "first_name": "Winston",
              "last_name": "Churchill"
            }
          },
          {
            "openflow_log_id": 30964,
            "user_id": 1,
            "openflow_id": 2287,
            "description": "referencing document deleted for Steven Day",
            "event_type": "referencing_DOCUMENT_DELETED",
            "createdAt": "2025-06-26T09:11:31.064Z",
            "updatedAt": "2025-06-26T09:11:31.064Z",
            "user": {
              "user_id": 1,
              "first_name": "Winston",
              "last_name": "Churchill"
            }
          }
        ]}
        onClose={() => setactivityTimelineModalVisible(false)}
      />
      <ConfirmationDialog
        open={showUnArchiveModal}
        onClose={() => setShowUnArchiveModal(false)}
        title="Unarchive Property?"
        message="Are you sure you want to unarchive this flow?"
        onConfirm={() => {
          ajax.post(`${Urls.unarchive}?flow_id=${flow.openflow_id}`, {})
            .then(({ data }) => {
              setShowUnArchiveModal(false);
              if (data.status) {
                showSuccesToast("Flow unarchived successfully");
                flow?.is_completed ? navigate("CompletedOnboards") : navigate("CurrentOnboards")

              } else {
                showErrorToast(data.message || "Failed to unarchive flow");
              }
            })
            .catch(() => showErrorToast("Failed to unarchive flow"));
        }}
      />
      <ConfirmationDialog
        open={showArchiveModal}
        onClose={() => setShowArchiveModal(false)}
        title="Archive Property?"
        message="Are you sure you want to archive this flow?"
        onConfirm={() => {
          ajax.post(`${Urls.archive}?flow_id=${flow.openflow_id}`, {})
            .then(({ data }) => {
              setShowArchiveModal(false);
              if (data.status) {
                showSuccesToast("Flow archived successfully");
                navigate("ArchivedOnboards")
              } else {
                showErrorToast(data.message || "Failed to archive flow");
              }
            })
            .catch(() => showErrorToast("Failed to archive flow"));
        }}
      />

      <ConfirmationDialog
        open={showConfirmDialog}
        onClose={() => setShowConfirmDialog(false)}
        title="Delete flow?"
        message="Are you sure you want to delete this flow? This action cannot be undone."
        onConfirm={() => {
          ajax.delete(Urls.START_FLOW, { params: { flow_id: flow?.openflow_id } })
            .then(({ data }) => {
              setShowConfirmDialog(false);
              if (data.status) {
                navigate("CurrentOnboards")
                showSuccesToast("Flow deleted successfully");
              } else {
                showErrorToast(data.message || "Failed to delete flow");
              }
            })
            .catch(() => showErrorToast("Failed to delete flow"));
        }}
      />
      <Dialog
        open={showCompleteModal}
        onClose={() => setShowCompleteModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title"> Move to Property? </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to complete this onboard?
          </DialogContentText>
          <DialogContentText id="alert-dialog-description">
            If you select "YES", the flow will be moved to the "completed onboards" section
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <DialogButton onClick={() => {
            ajax.post(`${Urls.complete}?flow_id=${openflow_id}`, {}).then(({ data }) => {
              setShowCompleteModal(false)
              if (data.status) {
                dispatch(tenantActions.getFlowInfo(openflow_id))
                showSuccesToast("Request completed successfully")
                navigate("CompletedOnboards")
              } else {
                toast.error(data.message)
              }
            }).catch(() => {
              showErrorToast("Failed to archieve Flo")
            })

          }} color="primary" autoFocus>
            Yes
          </DialogButton>
          <DialogButton onClick={() => {
            setShowCompleteModal(false)
          }} color="primary">
            No
          </DialogButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={showCompleteWarningModal}
        onClose={() => setShowCompleteWarningModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Please note: You must tick complete on all of the sections of the flo to complete the tenant progression.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <DialogButton onClick={() => {
            setShowCompleteWarningModal(false)
          }} color="primary" autoFocus>
            Ok
          </DialogButton>

        </DialogActions>
      </Dialog>
    </>
  );
};
const ConfirmationDialog = ({ open, onClose, title, message, onConfirm }) => (
  <Dialog
    open={open}
    onClose={onClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-description">
        {message}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <DialogButton onClick={onClose} color="primary">
        Cancel
      </DialogButton>
      {onConfirm ? <DialogButton onClick={onConfirm} color="primary" autoFocus>
        Confirm
      </DialogButton> : null}
    </DialogActions>
  </Dialog>
);

const styles = StyleSheet.create({
  actionButtons: {
    marginTop: 8,
  },
  topActions: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 12,
  },
  actionButton: {
    alignItems: 'center',
    paddingHorizontal: 8,
  },
  actionLabel: {
    fontSize: 12,
    fontWeight: '500',
    marginTop: 4,
  },
  ctaButton: {
    paddingVertical: 12,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
  },
  card: {
    marginVertical: 16,
    borderRadius: 14,
    backgroundColor: '#fff',
    shadowColor: '#000',
    shadowOpacity: 0.05,
    shadowRadius: 8,
    shadowOffset: { width: 0, height: 2 },
    elevation: 3,
    overflow: 'hidden',
  },
  bannerWrapper: {
    height: 140,
  },
  banner: {
    flex: 1,
    justifyContent: 'flex-end',
    padding: 14,
  },
  homeText: {
    color: 'white',
    fontSize: 14,
    fontWeight: 'bold',
  },
  content: {
    paddingHorizontal: 16,
    flexDirection: 'row',
    justifyContent: "space-between",
    alignItems: "center",
    paddingVertical: 16
  },
  addressText: {
    color: '#9333ea',
    fontWeight: 'bold',
    marginBottom: 10,
    fontSize: 18,
  },
  iconsRow: {
    flexDirection: 'row',
    gap: 16,
    marginBottom: 16,
  },
  progressRow: {
    alignItems: 'center',
    gap: 20,
    justifyContent: 'flex-end'
  },
  progressText: {
    fontSize: 12,
    color: '#6b7280',
    marginTop: 6,
    textAlign: 'center',
  },
  completeRow: {
    // flexDirection: 'row',
    alignItems: 'center',
    gap: 6,

  },
  completeText: {
    fontSize: 12,
    color: '#444',
    textAlign: 'center',
  },
});

export default FlatOverviewCard;
